export default {
  name: 'VideoHive',
  abbreviation: 'VH',
  domain: 'videohive.net',
  google_analytics_id: 'UA-11834194-8',
  google_remarketing_label: 'NrSdCMX_uQMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. photo slideshow',
  features: {
    /**
     * @description Show date updated filter
     * @author Javed
     * @expires
     */
    dateUpdatedFilter: true,
    /**
     * @description
     * @author Geoff Evason
     * @expires
     */
    'collapse-tags-unless-bottom-category': true,
    /**
     * @description Enable cookiebot
     * @author Luke Robins
     * @expires
     */
    cookiebot: true
  },
  ui: {
    featured_hero_item_viewtype: 'grid',
    item_list_views: [
      {
        value: 'grid',
        label: 'Grid'
      }
    ]
  }
}
